import React, { forwardRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  helperText?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
  fullWidth?: boolean;
}
const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  helperText,
  error,
  options,
  fullWidth = true,
  className = '',
  id,
  ...props
}, ref) => {
  const selectId = id || `select-${Math.random().toString(36).substr(2, 9)}`;
  const baseSelectStyles = 'block bg-white rounded-md shadow-sm focus:ring-2 focus:ring-offset-0 focus:outline-none transition-colors duration-200 appearance-none';
  const stateStyles = error ? 'border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500';
  const sizeStyles = 'py-2 pl-3 pr-10 text-sm';
  const widthStyles = fullWidth ? 'w-full' : '';
  const combinedClassName = `
    ${baseSelectStyles}
    ${stateStyles}
    ${sizeStyles}
    ${widthStyles}
    ${className}
  `.trim();
  return <div className={fullWidth ? 'w-full' : ''} data-id="element-190">
        {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-191">
            {label}
          </label>}
        <div className="relative" data-id="element-192">
          <select ref={ref} id={selectId} className={combinedClassName} {...props} data-id="element-193">
            {options.map(option => <option key={option.value} value={option.value} data-id="element-194">
                {option.label}
              </option>)}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" data-id="element-195">
            <ChevronDownIcon className="h-4 w-4 text-gray-500" data-id="element-196" />
          </div>
        </div>
        {(helperText || error) && <p className={`mt-1 text-xs ${error ? 'text-red-600' : 'text-gray-500'}`} data-id="element-197">
            {error || helperText}
          </p>}
      </div>;
});
Select.displayName = 'Select';
export default Select;